module.exports = __webpack_public_path__ + "img/5.fd794306.png";